<div
  class="flex w-100 justify-content-center px-16 py-24 flex-column align-items-center">
  <img
    class="mb-20 w-100px"
    src="./assets/icon/logo-passer-morado.png"
    alt="passer" />
  <form
    class="w-100"
    id="form-login"
    [formGroup]="loginForm"
    (ngSubmit)="onLoginSubmit()">
    <div id="email-div">
      <ps-input
        autocomplete="username"
        height="tall"
        name="email"
        type="email"
        [fieldLanguage]="currentLanguage"
        [formDataControl]="email"
        [label]="'labels.email' | translate">
      </ps-input>
    </div>
    <div class="mt-8">
      <ps-input
        autocomplete="current-password"
        height="tall"
        name="password-login"
        type="password"
        [fieldLanguage]="currentLanguage"
        [formDataControl]="password"
        [isPass]="true"
        [label]="'labels.pass' | translate">
      </ps-input>
    </div>

    <div class="mb-3">
      <ps-button
        buttonClass="mt-16"
        class="w-100"
        data-testid="login"
        height="tall"
        type="submit"
        width="100%"
        [disabled]="loginForm.invalid"
        [text]="'login.sign' | translate">
      </ps-button>
    </div>
  </form>

  <div class="divider w-100 mt-24 mb-16"></div>

  <a
    class="color-psr-text-title-modal cursor-pointer f13"
    data-testid="forgot-pass"
    (click)="forgetPass()">
    {{ 'login.forg_pass' | translate }}
  </a>

  <p class="f13 mt-32 mb-16">{{ 'login.no_account' | translate }}</p>
  <ps-button
    class="w-100"
    color="secondary"
    data-testid="btn-register"
    height="tall"
    width="100%"
    [text]="'login.register_copny' | translate"
    (onClick)="goTo()">
  </ps-button>

  <div class="mt-16 flex flex-row align-items-center w-100 justify-content-end">
    <img
      class="w-30px h-30px mb-0 mr-4 radius-50 cursor-pointer"
      src="{{ lang.icon }}"
      (click)="openLangModal()" />
    <span
      class="f13 cursor-pointer"
      data-testid="lang-modal"
      (click)="openLangModal()"
    >
      {{ lang.name }}
    </span>
  </div>
</div>
